import React from 'react';
import countriesData from '../../data/countries.json';

const Statistics = () => {
    const totalCountriesVisited = countriesData.filter(country => country.status === 'visited').length;
    const totalCountriesToVisit = countriesData.filter(country => country.status === 'to visit').length;
    const totalCitiesToVisit = countriesData.filter(country => country.status === 'to visit')
        .reduce((count, country) => count + country.cities.length, 0);

    const longestStay = countriesData.filter(country => country.status === 'visited')
        .reduce((max, country) => Math.max(max, country.duration), 0);

    const mostVisitedCity = countriesData.flatMap(country => country.cities)
        .reduce((maxCity, city) => (city.visitCount > maxCity.visitCount ? city : maxCity), { name: '', visitCount: 0 });

    const totalDistanceCovered = "Simplified calculation - requires complex logic or APIs";

    const mostVisitedContinent = countriesData.filter(country => country.status === 'visited')
        .reduce((acc, country) => {
            acc[country.continent] = (acc[country.continent] || 0) + 1;
            return acc;
        }, {});

    let mostVisitedContinentName = '';
    let maxVisits = 0;
    for (const continent in mostVisitedContinent) {
        if (mostVisitedContinent[continent] > maxVisits) {
            maxVisits = mostVisitedContinent[continent];
            mostVisitedContinentName = continent;
        }
    }

    const totalCitiesVisited = countriesData.filter(country => country.status === 'visited')
        .reduce((count, country) => count + country.cities.length, 0);

    const totalContinentsVisited = Object.keys(mostVisitedContinent).length;

    return (
        <div className="statistics">
            <h3>Travel Statistics</h3>
            <p>Total Countries Visited: {totalCountriesVisited}</p>
            <p>Total Cities Visited: {totalCitiesVisited}</p>
            <p>Total Continents Visited: {totalContinentsVisited}/5</p>
            <p>Most Visited Continent: {mostVisitedContinentName}</p>
        </div>
    );
};

export default Statistics;
